import './MBBeVoDesc.css';
import MBBeVoContent from '../MBBeVoContent/MBBeVoContent';
import {useTranslation} from 'react-i18next';

const MBBeVoDesc = () => {
    const {t} = useTranslation();
    t('MbOgOil');
    t('MbChoice');
    t('OperatingInstructions');
    t('OperatingInstructionsContent');
    return (
        <div>
            <div style={{marginTop: '48px'}} className='wb-grid-container'>
                <div className='wb-grid-row custom-blocks'>
                    <MBBeVoContent/>
                </div>
            </div>
        </div>
    );
};

export default MBBeVoDesc;
